// extracted by mini-css-extract-plugin
module.exports = {"navContainer":"root_navContainer__2hPl0","screenContainer":"root_screenContainer__3_W5K"};